import { gql } from "@apollo/client";

export const VENUE_USER_FRAGMENT = gql`
  fragment VenueUser on VenueUser {
    id
    firstName
    lastName
    role
    venueId
    userId
    createdAt
    updatedAt
  }
`;
